<template>
  <v-card class="elevation-0 mt-0 rounded-0">
    <v-card
      id="title_map_snapshot"
      class="container_showonmap ma-3 elevation-0 rounded-0 mt-0 pb-3 mt-0"
      style="border: solid 1px #e0e0e0"
    >
      <v-toolbar color="#F7F7F7" dense class="elevation-0 rounded-0">
      </v-toolbar>

    
      <v-card
        class="elevation-0 rounded-0 ma-3"
        color="#FFF"
        style="border: solid 1px #e0e0e0"
      >
        
        <v-container style="margin-top: 0" fill-height fluid>
          <v-row align="center" justify="center">
            <v-col
              ><img
                alt="Navplus logo"
                width="70px"
                :src="loadernavplus"
                class="justify-center"
            /></v-col>
          </v-row>
        </v-container>

        <v-divider></v-divider>
        <v-toolbar dense class="elevation-0 rounded-0" color="#f7f7f7">
        </v-toolbar>
      </v-card>
      <v-card
        class="elevation-0 rounded-0 ma-3 mt-0 mb-0"
        style="border: solid 1px #e0e0e0"
      >

        <v-card class="elevation-0 rounded-0">
          <v-container style="margin-top: 0" fill-height fluid>
            <v-row align="center" justify="center">
              <v-col
                ><img
                  alt="Navplus logo"
                  width="70px"
                  :src="loadernavplus"
                  class="justify-center"
              /></v-col>
            </v-row>
          </v-container>
          <v-divider></v-divider>
          <v-toolbar dense class="elevation-0 rounded-0" color="#f7f7f7">
          </v-toolbar>
        </v-card>
      </v-card>
    </v-card>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import $ from "jquery";
export default {
  data() {
    return {
      searchFolder: "",
      itemsPerPage: 10,
      showpictonclick: null,
      page: 1,
      pageCount: 0,
      itemsPerPageImage: 25,
      pageImage: 1,
      pageCountImage: 0,
      itemsPerPageFolders: 25,
      pageFolders: 1,
      pageCountFolders: 0,
      pageSize: 1,
      loadernavplus: require("@/assets/img/load100new.gif"),
      folderclose: require("@/assets/img/close-folder.png"),
      folderloading: require("@/assets/img/loading-folder.png"),
      foldercloseagain: require("@/assets/img/close-folder.png"),
      folderopen: require("@/assets/img/open-folder.png"),
      headersFolder: [{ text: "Company", value: "", sortable: false }],
    };
  },
  methods: {
    ...mapActions([
      "closeShow",
      "fetchSnapshot",
      "snapshotFolder",
      "FolderClick",
      "vesselDataSet",
      "FilterClick",
      "addsnapshot_executed",
    ]),

    async onFolderClick(id, label) {
      $("html, body").animate(
        {
          scrollTop: $("#title_map_snapshot").offset().top - 108,
        },
        800
      );
      this.folderOnSelect = null;
      const dataimg = {
        id: id,
        label: label,
        token: localStorage.getItem("token"),
      };
      console.log(label);
      console.log(this.vesselData.id);
      this.FolderClick(dataimg);
    },

    kFormatter(num) {
      return Math.abs(num) > 999
        ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + "k"
        : Math.sign(num) * Math.abs(num);
    },
  },

  mounted() {
    var mama = this;
    if (!mama.snapshot_executed) {
      //console.log("jalan title map");
      mama.addsnapshot_executed(true);
      $("html, body").animate(
        {
          scrollTop: $("#title_map_snapshot").offset().top - 108,
        },
        800
      );
    } else {
      ////console.log("Muncul"), //console.log(mama.sailink_executed);
    }
  },

  computed: {
    ...mapGetters([
      "folderSelect",
      "filterList",
      "snapshotData",
      "snapshotpict",
      "snapshotfolder",
      "loadingimage",
      "loadingfolder",
      "vesselData",
      "snapshot_executed",
    ]),
  },
};
</script>

<style lang="scss" scoped>
.margintab {
  margin-top: -25px;
}

.bxfile {
  font-size: 40px;
}

.imgsnapshot {
  width: 150px;
  margin: 10px;
}

.datasnapshot {
  top: 70px;
}

.image th {
  background-color: #0479f5;
  color: #fff;
}

.image {
  background-color: #ffff;
}

.image tbody {
  display: flex;
  white-space: initial;
  flex-wrap: wrap;
  text-align: center;
  width: 104vw;
  padding: 1em 1em 0.5em 0.5em;
}
</style>
